import { Suspense, useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'
import { useAtomValue } from 'jotai'
import {
	UnknownPage,
	AccountPage,
	DashboardPage,
	LoadingPage,
	LoginPage,
	OfferNameGenerationPage,
	OfferPage,
	OfferScopePage,
	RolePage,
	OfferSpendByAccountPage,
	OfferSpendByOfferPage,
	OfferSpendByOfferScopePage,
	OfferSpendPage,
	RevenueSpendPage,
	RevenueAgencyPage,
	RevenueSpendByAccountPage,
	RevenueSpendByTeamPage,
	PostbackSendPage,
	AffiliatePage
} from '../pages'

import * as layouts from './layouts'
import * as state from '../states'

import 'react-tooltip/dist/react-tooltip.css'

import './App.scss'
import './styles/main.scss'
import { Access } from '../lib'
import { ERoleAccess } from '../types'
import { MENU } from '../constants'

export const App = () => {
	const isThemeDark = useAtomValue(state.themeIsDarkAtom)
	const isAuth = useAtomValue(state.isAuthAtom)
	const profile = useAtomValue(state.profileAtom)
	const $access = new Access(profile ?? null)

	// toggle body class 'dark-theme' - according to isThemeDark state
	useEffect(() => {
		if (isThemeDark) {
			document.body.classList.add('dark-theme')
		} else {
			document.body.classList.remove('dark-theme')
		}
	}, [isThemeDark])

	return <>
		<Suspense fallback={<LoadingPage/>}>
			<BrowserRouter>
				<Routes>
					<Route element={<layouts.IndexLayout/>}>
						{isAuth === false ? (
							<Route element={<layouts.UnAuthLayout/>}>
								<Route path={MENU.login.url} element={<LoginPage/>}/>
							</Route>
						) : null}

						{isAuth === true ? (
							<Route element={<layouts.AuthLayout/>}>
								<Route index element={<DashboardPage/>}/>
								<Route path="/generation/offer/name" element={<OfferNameGenerationPage/>}/>
								<Route path="/generation/postback" element={<OfferNameGenerationPage/>}/>
								{
									MENU.offerScope.access($access) && (
										<Route path={MENU.offerScope.url} element={<OfferScopePage/>}/>
									)
								}
								{/* TODO: check OLD unused/unnecessary now route */}
								{
									!!$access.$(ERoleAccess.OfferList) && (
										<Route path="/offer" element={<OfferPage/>}/>
									)
								}
								{
									MENU.offerSpend.access($access) && (
										<Route path={MENU.offerSpend.url} element={<OfferSpendPage/>}/>
									)
								}
								{
									MENU.offerSpendReportByAccount.access($access) && (
										<Route path={MENU.offerSpendReportByAccount.url} element={<OfferSpendByAccountPage/>}/>
									)
								}
								{
									MENU.offerSpendReportByOffer.access($access) && (
										<Route path={MENU.offerSpendReportByOffer.url} element={<OfferSpendByOfferPage/>}/>
									)
								}
								{
									MENU.offerSpendReportByOfferScope.access($access) && (
										<Route path={MENU.offerSpendReportByOfferScope.url} element={<OfferSpendByOfferScopePage/>}/>
									)
								}
								{
									MENU.postbackSend.access($access) && (
										<Route path={MENU.postbackSend.url} element={<PostbackSendPage/>}/>
									)
								}
								{
									MENU.revenueAgency.access($access) && (
										<Route path={MENU.revenueAgency.url} element={<RevenueAgencyPage/>}/>
									)
								}
								{
									MENU.affiliate.access($access) && (
										<Route path={MENU.affiliate.url} element={<AffiliatePage/>}/>
									)
								}
								{
									MENU.revenueSpend.access($access) && (
										<Route path={MENU.revenueSpend.url} element={<RevenueSpendPage/>}/>
									)
								}
								{/*TODO: check the route for the future RevenueSpendByAccountsPage ?*/}
								{/*{
									MENU.revenueSpendReportByAccounts.access($access) && (
										<Route path={MENU.revenueSpendReportByAccounts.url} element={<RevenueSpendByAccountsPage/>}/>
									)
								}*/}
								{
									MENU.revenueSpendReportByAccount.access($access) && (
										<Route path={MENU.revenueSpendReportByAccount.url} element={<RevenueSpendByAccountPage/>}/>
									)
								}
								{
									MENU.revenueSpendReportByTeam.access($access) && (
										<Route path={MENU.revenueSpendReportByTeam.url} element={<RevenueSpendByTeamPage/>}/>
									)
								}
								{
									MENU.account.access($access) && (
										<Route path={MENU.account.url} element={<AccountPage/>}/>
									)
								}
								{
									MENU.role.access($access) && (
										<Route path={MENU.role.url} element={<RolePage/>}/>
									)
								}
							</Route>
						) : null}

						{/*<Route path="*" element={isAuth === true ? <DashboardPage/> : isAuth === false ? <LoginPage /> : <UnknownPage /> }/>*/}
						<Route path="*" element={<UnknownPage/>}/>
					</Route>
				</Routes>
			</BrowserRouter>
		</Suspense>
	</>
}
